import React from 'react';

function About() {
  return (
    <div>
      <h2>About Page</h2>
      <p>This is the content of the About page.</p>
    </div>
  );
}

export default About;
